import React, { useState } from "react";
import { Flex, Text } from "@chakra-ui/react";
import dummy from "../../assets/svg/dummy.svg";
import person from "../../assets/svg/person.svg"; import person1 from "../../assets/svg/person1.svg";
import left from "../../assets/svg/left.svg";
import right from "../../assets/svg/right.svg";

const slidesData = [
  {
    text: [
      "We saw a transformative shift in our marketing reports and are able to strategize even better than before. All thanks",
      " to the SMSFlash tool for delivering real-time insights that empowered our data-driven decisions eventually",
      "resulting in substantial ROI growth.",
    ],
    author: "Ashish Sharma",
    // image: dummy, // Add the image path here,
    role: "Digital Marketing Director",
  },
  {
    text: [
      "The SMSFlash tool has truly revolutionized our marketing approach by providing us with real-time insights.This has",
      "enabled us to make more effective, data-driven decisions driving remarkable ROI growth and helping",
      "us optimize our strategies with greater precision.",
    ],
    author: "Robinson",
    // image: person, // Add the image path here,
    role: "Sales Director",
  },
  {
    text: [
      "We’ve experienced a remarkable shift in our marketing strategies thanks to the real-time insights provided by the ",
      "SMSFlash tool, Its ability to deliver actionable data has empowered us to make more informed decisions ",
      "  leading to a significant boost in ROI",
    ],
    author: "Mayank Rai",
    // image: person1, // Add the image path here,
    role: "Marketing Manager",
  },
];

function Review() {

  const [currentSlide, setCurrentSlide] = useState(0);

  const handleSlideChange = (newSlide) => {
    if (newSlide >= 0 && newSlide < slidesData.length) {
      setCurrentSlide(newSlide);
    }
  };
  return (
    <>
      <Text
        mt="5rem"
        textAlign="center"
        color="rgba(38, 50, 56, 1)"
        fontFamily="Roboto"
        fontWeight="700"
        fontSize="37px"
        lineHeight="46.88px"
        padding={'0.5rem'}
      >
        Here’s What Clients Says about️️ SmsFlash
      </Text>
      <Flex mt="2rem" justifyContent="center">
        <Flex
          gap="1rem"
          direction="column"
          w="80%"
          borderRadius="48px"
          h="480px"
          bg="linear-gradient(148.13deg, rgba(57, 14, 247, 0.08) 16.69%, rgba(146, 68, 244, 0.08) 84.78%)"
        >
          <Flex
            mt="5rem"
            direction="column"
            textAlign="center"
            fontFamily="Palanquin"
            fontWeight="400"
            fontSize="18px"
            lineHeight="28.8px"
            color="rgba(38, 50, 56, 1)"
          >
            {slidesData[currentSlide].text.map((textBlock, index) => (
              <Text key={index}>{textBlock}</Text>
            ))}


          </Flex>
          <Flex
            gap=".5rem"
            fontFamily="Montserrat"
            fontSize="16px"
            lineHeight="19.5px"
            color="rgba(38, 50, 56, 1)"
            direction="column"
            alignItems="center"
          >
            <Flex w="64px" h="64px" borderRadius="50%">
              {/* <img src={slidesData[currentSlide].image} alt="Author" /> */}
            </Flex>
            <Text fontWeight="700">{slidesData[currentSlide].author}</Text>
            <Text fontWeight="500">{slidesData[currentSlide].role}</Text>
          </Flex>

          <Flex mt="3rem" justifyContent="center" align="center" gap="1rem">
            <img
              src={left}
              alt="Previous"
              style={{ cursor: "pointer" }}
              onClick={() => handleSlideChange(currentSlide - 1)}
            />
            <Text>
              {currentSlide + 1}/{slidesData.length}
            </Text>
            <img
              src={right}
              alt="Next"
              style={{ cursor: "pointer" }}
              onClick={() => handleSlideChange(currentSlide + 1)}
            />
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}

export default Review;
